function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const FloatingLabelTextField = ({
  name,
  label,
  type,
  inputRef,
  helperText,
  trailingElement,
  errors,
  onChange,
  isMini,
  ...rest
}) => {
  // this is only needed for local value state to float the label
  const [value, setValue] = useState('');
  const inputFieldRef = useRef();

  const handleChange = e => {
    setValue(e.target.value);
    if (onChange) onChange(e);
  };

  const handleLabelClick = () => {
    if (inputFieldRef.current) inputFieldRef.current.focus();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames('form-group', {
      float: value.length > 0,
      error: errors !== undefined,
      'form-group--isMini': isMini
    })
  }, trailingElement ? /*#__PURE__*/React.createElement("div", {
    className: "input__trailing"
  }, /*#__PURE__*/React.createElement("input", _extends({
    name: name,
    type: type,
    ref: e => {
      inputRef && inputRef(e), inputFieldRef.current = e;
    },
    onChange: handleChange
  }, rest)), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: name,
    onClick: handleLabelClick()
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "input__trailing-element"
  }, trailingElement)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", _extends({
    name: name,
    type: type,
    ref: e => {
      inputRef && inputRef(e), inputFieldRef.current = e;
    },
    onChange: handleChange
  }, rest)), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: name,
    onClick: handleLabelClick
  }, label))), errors && /*#__PURE__*/React.createElement("div", {
    className: "help-text"
  }, errors.message), helperText && /*#__PURE__*/React.createElement("div", {
    className: "help-text"
  }, helperText));
};

FloatingLabelTextField.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string,
  errors: PropTypes.object,
  helperText: PropTypes.string,
  inputRef: PropTypes.func
};
FloatingLabelTextField.defaultProps = {
  type: 'text'
};
export default FloatingLabelTextField;